:host {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: var(--color-default-text);
  font-family: var(--font-family-sans);
  font-weight: var(--font-rg);
}

:host .modal-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: calc(var(--space-unit) * 2);
  row-gap: calc(var(--space-unit) * 2);
}

:host .modal-wrapper > .files-wrapper {
  display: flex;
  flex-direction: column;
  margin: calc(var(--space-unit) * 4);
  gap: var(--space-unit);
}

:host .text-container {
  display: flex;
  flex-direction: column;
  margin: auto;
  text-align: center;
}

:host .text-container .upload-link {
  color: var(--color-text-link-blue);
  cursor: pointer;
  text-decoration: underline;
}

:host .text-container .upload-link:focus-visible {
  box-shadow: var(--shadow-focus-primary);
  outline: none !important;
}

:host .text-container .upload-link-text {
  margin-bottom: var(--space-unit);
}

:host input[type="file"] {
  display: none;
}

:host #title + #description {
  margin-top: var(--space-unit);
}

:host > * + z-button,
:host > .files-container + *,
:host > .files-container:not(:first-child) {
  margin-top: calc(var(--space-unit) * 3);
}

:host > .files-container.hidden {
  display: none;
}

:host > .files-container > .uploaded-files-label {
  margin-bottom: calc(var(--space-unit) * 2);
}

:host > .files-container > .files-wrapper {
  display: flex;
  flex-wrap: wrap;
  column-gap: calc(var(--space-unit) * 2);
  row-gap: calc(var(--space-unit) * 2);
}

/* Tablet breakpoint */
@media (min-width: 768px) {
  :host > .container > z-button {
    align-self: flex-start;
  }

  :host .modal-wrapper {
    padding: calc(var(--space-unit) * 3);
  }
}

@media (min-width: 1152px) {
  :host .modal-wrapper {
    padding: calc(var(--space-unit) * 4);
  }
}
